import React from 'react'
import PlanDetails from './PlanDetails'
import { planAgeMapper } from '../../service/SimulatorContext'
export default function PlansCard({ plans, handleSetPlan, age, familyPlan = false }) {

  // planAgeMapper is display only (label/header) - standard plan AVAILABILITY is DB driven (minAgeMonths/maxAgeMonths)
  const planAgeHeader = planAgeMapper[(age > 3) ? 'default' : age]

  // Family plans come pre-grouped (premium / premium-with-inflation) from the backend.
  // Standard list is already filtered by getAvailablePlans - here we only sort for display.
  const plansDetails = familyPlan
    ? plans?.map(plan => <PlanDetails key={plan.route} plan={plan} handleSetPlan={handleSetPlan} />)
    : plans?.slice()
      .sort((a, b) => a.route - b.route).sort((a, b) => (a.minAgeMonths ?? 0) - (b.minAgeMonths ?? 0))
      .map(plan => <PlanDetails key={plan.route} plan={plan} handleSetPlan={handleSetPlan} />)

  return (
    <div className='plan-card'>
      <div className='card-header'>
        <p className='paln-label'>{familyPlan ? '' : planAgeHeader?.ageLabel}</p>
        <h3 className='plan-type'>{familyPlan ? 'התוכנית המשפחתית' : planAgeHeader?.header}</h3>
      </div>
      <div className='plans-wrapper'>
        {(familyPlan && !plans?.length) ? <p className='no-plans-message'>לא נמצא מסלול מתאים בתוכנית המשפחתית</p> : plansDetails}
      </div>
    </div>
  )
}
